import {createSelector} from '@reduxjs/toolkit'

const addressForFinancialRecordsSelector = createSelector(
    [state => state.components,
    state => state.primaryAgencyApplication.application?.businessLicenceData],
    (components, appData) => {
        let financialRecordsLocation = {singleLineAddress : ""}
        let criminalHistoryData = []

        if(appData) {
            if (appData.financialRecordsLocation) {
                financialRecordsLocation = appData.financialRecordsLocation
            }
            if(appData.criminalHistoryData) { 
                criminalHistoryData = appData.criminalHistoryData
            }
        }
            
        return Object.assign({}, 
            components.addressForFinancialRecords, 
            {criminalHistoryData},
            {financialRecordsLocation})
    }
)

export const addressForFinancialRecordsSelect = state => ({
    addressForFinancialRecords: addressForFinancialRecordsSelector(state)
})

export function populateAddressForFinanceDetails(addressForFinance){ 

    if(addressForFinance) { 
        return {
            "Street address" : addressForFinance.street ?  addressForFinance.street : "",
            "City/Town" : addressForFinance.city ?  addressForFinance.city : "",
            "Province" : addressForFinance.province ?  addressForFinance.province : "",
            "Postal code" : addressForFinance.postalCode ?  addressForFinance.postalCode : "",
        }
    }

    return {
        "Street address" : "",
        "City/Town" : "",
        "Province" : "",
        "Postal code" : "",
    }
}
